export const normaliseEmail = (email = '') => email.trim().toLowerCase();

export const hashPassword = async (password = '') => {
  const value = String(password);
  if (!value) return '';

  const encoder = new TextEncoder();
  const digest = await crypto.subtle.digest('SHA-256', encoder.encode(value));

  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};

export const buildAccessToken = async (linkId, email, password) => {
  const recipientEmail = normaliseEmail(email);
  const passwordHash = await hashPassword(password);

  if (!linkId || !recipientEmail || !passwordHash) return '';

  return hashPassword(`${linkId}:${recipientEmail}:${passwordHash}`);
};
